import React from 'react';
import './About.css';

const About = () => {
  return (
    <section id="about" className="about">
      <div className="container">
        <h2 className="section-title">About Me</h2>
        <div className="about-content">
          <div className="about-text">
            <p>
              I'm John Nathaniel, a versatile Project Manager and AI Lead Developer 
              adept at navigating the ever-evolving world of technology. 
              I specialize in creating robust, scalable AI solutions and leading development 
              teams to meet unique project requirements.
            </p>
            <p>
              I combine technical expertise with strategic project management and creative 
              problem-solving to deliver projects that exceed expectations. I believe in the 
              power of innovation, continuous learning, and effective leadership to stay ahead 
              in the fast-paced tech industry.
            </p>
            <div className="skills">
              <h3>My Approach</h3>
              <div className="skills-grid">
                <span className="skill-tag">Collaborative</span>
                <span className="skill-tag">Innovative</span>
                <span className="skill-tag">Agile</span>
                <span className="skill-tag">Quality-Focused</span>
                <span className="skill-tag">Client-Centric</span>
                <span className="skill-tag">Scalable</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;


